import { getThemedData } from '$app/utilities'

import carro from './carro'
import motto from './motto'

export const AuthLogo = getThemedData({
  motto,
  carro,
  partner: carro
})

export default AuthLogo
